// removed by extract-text-webpack-plugin
module.exports = {"small":"(min-width:600px)","medium":"(min-width:768px)","large":"(min-width:1200px)","grid":"tabletportrait__grid___30PVR","gridItem":"tabletportrait__gridItem___37ylB","device":"tabletportrait__device___3qGvZ","deviceContent":"tabletportrait__deviceContent___qD2UE","deviceScreen":"tabletportrait__deviceScreen___10S-b","img":"tabletportrait__img___3xqKq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TabletPortrait/tabletportrait.css
// module id = 168
// module chunks = 0